import "./src/assets/sass/partials/variables.scss"
import "./global.css"

const versionData = require("./version.json");  

export const onClientEntry = () => {
  const CURRENT_VERSION = versionData.version;
  const STORED_VERSION = localStorage.getItem("SITE_VERSION");

  if (STORED_VERSION !== CURRENT_VERSION) {
    console.log("[Gatsby] Nova versão detectada. Limpando cache...");

    localStorage.clear();
    sessionStorage.clear();

    document.cookie.split(";").forEach(c => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

    localStorage.setItem("SITE_VERSION", CURRENT_VERSION);
    window.location.reload(true);
  }
};